import classNames from "classnames";

import HeaderNavItemContext from "./HeaderNavItemContext";

function HeaderNavItem({
  icon,
  name,
  description,
  badge,
  to,
  onClick,
  styles,
  navigate,
}) {
  const handleNavigation = () => {
    if (to) {
      if (navigate) {
        navigate(to); //  SPA navigation
      } else {
        window.location.href = to; // fallback
      }
    } else if (onClick) {
      onClick();
    }
  };

  return (
    <div
      onClick={handleNavigation}
      className={classNames({
        "flex flex-row items-center gap-3 cursor-pointer p-3 w-full": true,
        "transition-all duration-200 ease-in-out": true,
        "hover:bg-gray-200 dark:hover:bg-dark-600": true,
        [`${styles}`]: styles,
      })}
    >
      <HeaderNavItemContext
        icon={icon}
        name={name}
        description={description}
        badge={badge}
      />
    </div>
  );
}

export default HeaderNavItem;
